import React from "react";

const dropCustomComponent = (props) => <div>Drop custom </div>;

export default React.memo(dropCustomComponent);
